import React from 'react'
import { createPortal } from 'react-dom'
import { useDispatch } from 'react-redux'
import { Backdrop } from './mixins'
import CartComponent from './CartComponent'
import { closeCart } from '../../store/cart-v2/modal/actionsToDo'
import ErrorNotification from './Notification/Error'
import AddItemNotification from './Notification/AddItem'
import { useCanCLientBuying } from '../../hooks/ecommerce/validate-client-buying-hook'
import { TypeNotification } from '../../store/cart-v2/notification/types'

const Notification = ({ typeNotification }) => {
  if (typeNotification === TypeNotification.ERROR) {
    return <ErrorNotification />
  }
  return <AddItemNotification />
}

const SidebarContainer = ({ isOpened, typeNotification }) => {
  const dispatch = useDispatch()
  const { enabledEcommerce } = useCanCLientBuying()
  if (!enabledEcommerce) {
    return null
  }

  return (
    <>
      <Notification typeNotification={typeNotification} />
      <Backdrop onClick={() => dispatch(closeCart())} isOpened={isOpened} />
      <CartComponent isOpened={isOpened} />
    </>
  )
}

const MemoComponent = React.memo(SidebarContainer)

const Component = ({ isOpened, typeNotification }) => {
  const portalElement = document.getElementById('sidebars')

  return createPortal(
    <MemoComponent isOpened={isOpened} typeNotification={typeNotification} />,
    portalElement as HTMLElement
  )
}

export default Component
